// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1ol69","productName":"Table_productName__3EmBV"};